import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { ProvPayerService } from '../../services/prov-payer.service';
import { USER_TYPE } from 'src/app/core/Constants/static';
import { UserService } from 'src/app/core/Services/user.service';
import { UserProfile } from 'src/app/core/Models/interfaces/user-details';
import { ToasterComponent } from 'src/app/shared/components/toaster/toaster.component';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Component({
  selector: 'app-payer-view',
  templateUrl: './payer-view.component.html',
  styleUrls: ['./payer-view.component.css']
})
export class PayerViewComponent implements OnInit {
  @Input('payerId') payerId?: number | null;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() editPayer: EventEmitter<boolean> = new EventEmitter<boolean>();
  public preBlock = false
  showSlider: boolean = false;
  isAddPayer: boolean = false;
  isLoader: boolean = false;
  currentCompany: number = 0;
  copyText: string = 'copy';
  regulatorList: any[] = [];
  currencyList: any[] = [];
  stateList: any[] = [];
  cityList: any[] = [];
  detailsList: any;
  clientSecretMasked!:string;
  countryRegObjt: any;
  countryList: any[] = [];
  currencyObj: any;
  countryObjt: any;
  assCountryObjt: any;
  stateObjt: any;
  regulatorObjt: any;
  user: UserProfile | null;
  showEdit: boolean = false;
  constructor(
    private provPayerApiService: ProvPayerApiService,
    private provPayerService: ProvPayerService,
    private userService: UserService,
    
  ) {
    this.user = this.userService.getUserInfo();
  }

  ngOnInit(): void {
    this.getMasterLists();
    if (this.user?.userDetails?.userType === USER_TYPE.payer) {
      this.showEdit = false;
    } else {
      this.showEdit = true;
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.showSlider = true;
    });
  }
  getMasterLists() {
    this.isLoader = true;
    forkJoin([
      this.provPayerApiService.getRegulatorList(),
      this.provPayerApiService.getCurrencyList(),
      this.provPayerApiService.getCountryList(),
      this.provPayerService.getEditPayerDetails(this.payerId),
    ]).subscribe({
      next: (responseList) => {
        this.regulatorList = responseList[0];
        this.currencyList = responseList[1];
        this.countryList = responseList[2];
        this.detailsList = responseList[3]?.data[0];

        forkJoin([
          this.provPayerApiService.getStateList(Number(this.detailsList?.country)),
          this.provPayerApiService.getCityList(Number(this.detailsList?.region)),
        ]).subscribe({
          next: (res) => {
            this.stateList = res[0]?.data;
            this.cityList = res[1]?.data;
            this.getDetails();
            this.isLoader = false;
          }
        })
      }
    })
  }
  getDetails() {
    let currLabel: any;
    let stateLabel: any;
    let regCountryLabel: any;
    let tparegLabel: any;
    if(this.detailsList?.client_secret){
      let first = this.detailsList?.client_secret?.slice(0, 2);
      let last = this.detailsList?.client_secret?.substr(this.detailsList?.client_secret.length - 2);
      this.clientSecretMasked = first + '***********************' + last;
    }
   
    this.detailsList?.tpaPayers.forEach((el: any) => {

      let currency = this.currencyList?.find(curr => curr.currencyId == el?.currency);
      currLabel = currency?.currencyDesc;
      el['currLabel'] = currLabel;

      let stateobjt = this.stateList?.find(el3 => el3.regionId == el?.region);
      stateLabel = stateobjt?.regionName;
      el['stateLabel'] = stateLabel;

      let regCountryObjt = this.countryList?.find(el4 => el4.countryId == el?.credentials[0]?.country);
      regCountryLabel = regCountryObjt?.countryName;
      el['regCountryLabel'] = regCountryLabel;

      let tpaRegObjt = this.regulatorList?.find(reg => reg.regulatoryId == el?.credentials[0]?.regulatorId);
      tparegLabel = tpaRegObjt?.regulatoryAuthorityCode;
      el['tparegLabel'] = tparegLabel;
    })

    this.currencyObj = this.currencyList?.find(el => el.currencyId == this.detailsList?.currency);
    this.assCountryObjt = this.countryList?.find(el => el.countryId == this.detailsList?.assocCountry);
    this.countryObjt = this.countryList?.find(el => el.countryId == this.detailsList?.country);
    this.countryRegObjt = this.countryList?.find(el => el.countryId == this.detailsList?.credentials[0]?.country);
    this.stateObjt = this.stateList?.find(el => el.regionId == this.detailsList?.region);
    this.regulatorObjt = this.regulatorList?.find(el => el.regulatoryId == this.detailsList?.credentials[0]?.regulatorId);

  }
  showEditPopup() {
    setTimeout(() => {
      this.showSlider = false;
    });

    this.editPayer.emit(true);

  }
  closePopup() {
    this.payerId = null;
    this.close.emit(false);
  }
  copyMessage(item?: any) {
    this.copyText = 'copied'
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = item;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
  shift(left: boolean, right: boolean) {
    if (left && !right && this.currentCompany != 0) {
      this.currentCompany--;
    } else {
      if (this.currentCompany != this.detailsList.tpaPayers.length - 1) {
        this.currentCompany++;
      }
    }
  }
}
